import PostsList from "../../../../widgets/PostsList/components/PostsList/PostsList"

export default function Main() {
  return (
    <main>
      <PostsList />
    </main>
  )
}